export const MODULO_INICIAL = "glucometria";

export const MODULOS_MEDICION = [
	{ id: "glucometria", label: "Glucometría", descripcion: "Glicemia capilar" },
	{ id: "espirometria", label: "Espirometría", descripcion: "Capacidad pulmonar" },
	{ id: "lipidograma", label: "Lipidograma", descripcion: "Perfil de colesterol y triglicéridos" },
	{ id: "perimetroAbdominal", label: "Perímetro abdominal", descripcion: "Riesgo metabólico" },
];
